import CircleSpinner from '../../../circleSpinner/CircleSpinner';

import './CheckoutProgressSection.scss';

interface ICheckoutProgressSection {
  title: string;
}

const CheckoutProgressSection = ({ title }: ICheckoutProgressSection) => {
  return (
    <div className="checkout-progress-section">
      <CircleSpinner size={37} />
      <div className="checkout-progress-section__details">
        <p className="checkout-progress-section__caption">{title}</p>
        <p className="checkout-progress-section__status">You'll be asked to approve this purchase from your wallet.</p>
      </div>
    </div>
  );
};

export default CheckoutProgressSection;
